import React from 'react';
import { Card, Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { ControlTowerQueryParams } from '@/services/manufacturingControlTower.service';
import { useControlTowerOutsourced } from '@/hooks/useManufacturingControlTower';

const OutsourcedOperationsTower: React.FC<{ filters?: ControlTowerQueryParams }> = ({ filters }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useControlTowerOutsourced(filters);
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];

  return (
    <Card
      id="outsourced"
      title="Outsourced operations tower"
      extra={<a onClick={() => navigate('/mfg/reports/outsourced-fabrication')}>Full report</a>}
      style={{ marginTop: 16 }}
    >
      <Table
        size="small"
        loading={isLoading}
        rowKey={(r) => `${r.work_order_id}-${r.production_unit_number}-${r.operation_name}`}
        dataSource={rows}
        columns={[
          { title: 'WO', dataIndex: 'work_order_number' },
          { title: 'Operation', dataIndex: 'operation_name' },
          { title: 'Unit', dataIndex: 'production_unit_number', width: 70 },
          { title: 'PR', dataIndex: 'pr_number' },
          {
            title: 'Trace',
            dataIndex: 'outsourced_trace_status',
            render: (s: string) => <Tag>{s}</Tag>,
          },
          { title: 'Stage', dataIndex: 'stage_status' },
        ]}
        pagination={{ pageSize: 15 }}
      />
    </Card>
  );
};

export default OutsourcedOperationsTower;
